/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const get_bd_group_info_from_member = createAsyncThunk(
  'BD/get_bd_group_info_from_member',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_bd_group_info_from_member',
      p,
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_bd_group_overview = createAsyncThunk(
  'BD/get_bd_group_overview',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_bd_group_overview', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const update_bd_group_info_from_app = createAsyncThunk(
  'BD/update_bd_group_info_from_app',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/update_bd_group_info_from_app',
      p,
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const get_member_info_by_show_id = createAsyncThunk(
  'BD/get_member_info_by_show_id',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/account/get_member_info_by_show_id',
      p,
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const common_invite = createAsyncThunk(
  'BD/common_invite',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/common_invite', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const operate_bd_group_member = createAsyncThunk(
  'BD/operate_bd_group_member',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/operate_bd_group_member', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const get_bd_union_data_overview = createAsyncThunk(
  'BD/get_bd_union_data_overview',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_bd_union_data_overview', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const get_bd_info_in_group = createAsyncThunk(
  'BD/get_bd_info_in_group',
  async (p: any, store: any) => {
    const {bd_mid} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/union/get_bd_info_in_group',
      {bd_mid},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_group_invite_bd_status = createAsyncThunk(
  'BD/get_group_invite_bd_status',
  async (p: any, store: any) => {
    const {invite_id} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/union/get_group_invite_bd_status',
      {invite_id},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const common_confirm_invite = createAsyncThunk(
  'BD/common_confirm_invite',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/common_confirm_invite', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export enum InviteBdStatusEnum {
  占位 = -10000,
  超时未继续开通失败 = -1000,
  已失效 = -3,
  已拒绝 = -2,
  待确认 = -1,
  已确认 = 1,
}

export enum BdUnionSettlementStatusEnum {
  正常 = 1,
  未达结算门槛 = 2,
  已解散 = 3,
  不结算 = 4,
}

export interface InitialStateType {
  groupData: any
  myNameUnionDetail: any
  myGroup: any
  curData: any
  land: any
}

const initialState: InitialStateType = {
  curData: {},
  groupData: {},
  myNameUnionDetail: {},
  myGroup: {},
  land: {},
}

export const BDSlice = createSlice({
  name: 'BD',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      get_bd_group_info_from_member.fulfilled,
      (state, action) => {
        Object.assign(state.myGroup, action.payload)
      }
    )
    builder.addCase(get_bd_group_overview.fulfilled, (state, action) => {
      Object.assign(state.groupData, action.payload)
    })
    builder.addCase(get_bd_union_data_overview.fulfilled, (state, action) => {
      Object.assign(state.myNameUnionDetail, action.payload)
    })
    builder.addCase(get_bd_info_in_group.fulfilled, (state, action) => {
      Object.assign(state.curData, action.payload)
    })
    builder.addCase(get_group_invite_bd_status.fulfilled, (state, action) => {
      Object.assign(state.land, action.payload)
    })
  },
})
export default BDSlice.reducer
export const BDActions = BDSlice.actions

export const useBDState = () => {
  const data = useSelector((state) => {
    return state.BD
  })
  return data
}
